export const ICT_SERVICE_TYPE_OPTIONS = [
  "Cloud computing services",
  "Software",
  "Data and information services",
  "Data centre services",
  "Business process outsourcing services",
  "ICT services supporting business functions",
  "Payment services",
  "Cybersecurity and information security services",
  "Digital identity management services",
  "ICT audit and testing services",
  "Network and communication services",
  "Transaction and trade execution services",
  "Market data services",
  "Regulatory reporting services",
  "ICT consultancy services",
  "Other ICT services",
] as const;

export const SUBSTITUTABILITY_OPTIONS = [
  "Easily substitutable",
  "Substitutable with moderate effort",
  "Highly complex substitutability",
  "Not substitutable",
] as const;

export const NON_SUBSTITUTABILITY_REASON_OPTIONS = [
  "Lack of alternative providers in the market",
  "Technical lock-in (proprietary technology)",
  "Data migration complexity",
  "Regulatory or compliance constraints",
  "High switching costs",
  "Contractual barriers",
  "Dependency on provider's ecosystem",
  "Specialized expertise requirements",
  "Integration complexity with existing systems",
  "Time constraints for transition",
  "Other",
] as const;

export const REINTEGRATION_POSSIBILITY_OPTIONS = [
  "Fully possible",
  "Partially possible",
  "Not possible",
  "Not applicable (intra-group provider)",
] as const;

export const DISCONTINUATION_IMPACT_OPTIONS = [
  "Critical - immediate business disruption",
  "Significant - major operational impact",
  "Moderate - manageable with workarounds",
  "Limited - minor impact",
  "Negligible",
] as const;

export const ALTERNATIVE_TPPS_IDENTIFIED_OPTIONS = [
  "Yes - multiple alternatives identified",
  "Yes - single alternative identified",
  "Partially - alternatives being evaluated",
  "No - no suitable alternatives found",
  "No - assessment not yet performed",
] as const;

export type IctServiceType = typeof ICT_SERVICE_TYPE_OPTIONS[number];
export type Substitutability = typeof SUBSTITUTABILITY_OPTIONS[number];
export type NonSubstitutabilityReason = typeof NON_SUBSTITUTABILITY_REASON_OPTIONS[number];
export type ReintegrationPossibility = typeof REINTEGRATION_POSSIBILITY_OPTIONS[number];
export type DiscontinuationImpact = typeof DISCONTINUATION_IMPACT_OPTIONS[number];
export type AlternativeTppsIdentified = typeof ALTERNATIVE_TPPS_IDENTIFIED_OPTIONS[number];
